export default {
  statWrapper: { mt: { xs: 3, lg: 1 }, gap: { xs: 1, lg: 2 } },
  statItem: { maxWidth: 374 },
  linkWrapper: { display: 'flex', pt: 4 },
  link: {
    textDecoration: 'none',
  },
};
